import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c1db247"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block container-box" }
const _hoisted_2 = { class: "from" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "from-item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "from-item-left" }, " 开具类型： "),
  /*#__PURE__*/_createElementVNode("div", { class: "from-item-right" }, " 企业 ")
], -1))
const _hoisted_4 = { class: "from-item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "from-item-left" }, " 税务登记证号： ", -1))
const _hoisted_6 = { class: "from-item-right" }
const _hoisted_7 = { class: "from-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "from-item-left" }, " 开票金额： ", -1))
const _hoisted_9 = { class: "from-item-right" }
const _hoisted_10 = { class: "active" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { class: "from-item alone" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "from-item-left" }, " 接收邮箱： ", -1))
const _hoisted_14 = { class: "from-item-right" }
const _hoisted_15 = { class: "from-item alone" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "from-item-left" }, " 接收手机号： ", -1))
const _hoisted_17 = { class: "from-item-right" }
const _hoisted_18 = { class: "from-item alone-btn" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_head = _resolveComponent("page-head")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_page_head, { title: "申请发票" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_alert, {
        title: "当月可以申请上个月的费用发票",
        type: "warning",
        "show-icon": "",
        style: {"width":"640px"}
      }),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.invoiceInfo.tax_number), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createTextVNode(_toDisplayString(_ctx.invoiceInfo.surplus) + " 元 ", 1),
            _createElementVNode("div", _hoisted_10, [
              _createTextVNode(" 注：此为截止到" + _toDisplayString(_ctx.invoiceInfo.cut_date) + "的可开票金额 ", 1),
              _hoisted_11,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoiceInfo.totalPremiumList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(item.month) + ": " + _toDisplayString(item.total) + "; ", 1))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
              type: "text",
              style: {"width":"310px"},
              placeholder: "请输入接收邮箱"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_el_input, {
              type: "text",
              style: {"width":"310px"},
              modelValue: _ctx.phone,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.phone) = $event)),
              placeholder: "请输入接收手机号"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("button", {
            class: "btn",
            style: {"width":"200px"},
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onApplyInvoice && _ctx.onApplyInvoice(...args)))
          }, " 确认申请 "),
          _hoisted_19
        ])
      ])
    ])
  ], 64))
}